export const selectNotes = ({ notes }) => notes
export const selectIsNotesLoading = ({ notes: { isLoading } }) => isLoading
